import { useCallback } from "react";

const SOFT_MANDATORY_FIELDS = [
    "ugDegree",
    "ugDepartment",
    "ugPassout",
    "ugPercentage",
    "pgDegree",
    "pgDepartment",
    "pgPassout",
    "pgPercentage",
    "experience",
    "location",
    "technicalScore",
    "communicationScore",
    "mockInterview",
    "mockTest1Score",
    "gender",
    "placementInterest",
    "diplomaDepartment",
    "diplomaPassout",
    "diplomaPercentage",
    "resumePath"
];

const SOFT_FIELD_LABELS = {
    ugDegree: "UG Degree",
    pgDegree: "PG Degree",
    ugPassout: "UG Passout",
    pgPassout: "PG Passout",
    ugPercentage: "UG Percentage",
    pgPercentage: "PG Percentage",
    pgDepartment: "PG Department",
    ugDepartment: "UG Department",
    experience: "Experience",
    location: "Preferred Job Location",
    technicalScore: "Technical Score",
    communicationScore: "Communication Score",
    mockInterview: "Mock Interview",
    mockTest1Score: "Mock Test 1 Score",
    studentContactNumber: "Student Contact Number",
    gender: "Gender",
    placementInterest: "Placement Interest",
    diplomaPercentage: "Diploma Percentage",
    diplomaPassout: "Diploma Passout",
    diplomaDepartment: "Diploma Department",
    resumePath: "Resume"
};

const ACADEMIC_GROUPS = {
    ug: ["ugDegree", "ugDepartment", "ugPassout", "ugPercentage"],
    pg: ["pgDegree", "pgDepartment", "pgPassout", "pgPercentage"],
    diploma: ["diplomaDegree", "diplomaDepartment", "diplomaPassout", "diplomaPercentage"],
};

export const useSoftMandatoryWarning = (formData) => {
    const getSoftMandatoryWarnings = useCallback(() => {
        if (!formData) return [];

        const getFilledGroup = () => {
            for (const [groupName, fields] of Object.entries(ACADEMIC_GROUPS)) {
                const isGroupStarted = fields.some((field) => {
                    const value = formData[field];
                    return value !== undefined && value !== null && value !== "" && value !== 0;
                });

                if (isGroupStarted) return groupName;
            }
            return null;
        };

        const activeAcademicGroup = getFilledGroup();

        const emptyFields = SOFT_MANDATORY_FIELDS.filter((field) => {
            const value = formData[field];
            const isAcademicField = Object.values(ACADEMIC_GROUPS).flat().includes(field);

            // Skip academic fields if no group started
            if (!activeAcademicGroup && isAcademicField) return false;

            // Only validate active group
            if (activeAcademicGroup && isAcademicField) {
                const allowedFields = ACADEMIC_GROUPS[activeAcademicGroup];
                if (!allowedFields.includes(field)) return false;
            }

            if (Array.isArray(value)) return value.length === 0;
            if (typeof value === "number") return value === 0 || isNaN(value);

            return value === undefined || value === null || value === "";
        });

        let warningLabels = emptyFields.map((f) => SOFT_FIELD_LABELS[f] || f);

        // Show academic warning if none selected
        if (!activeAcademicGroup) {
            warningLabels.unshift(
                "Please fill at least one education qualification (UG / PG / Diploma)"
            );
        }

        // 🔥 Project-1 Score (NEW ARRAY BASED LOGIC)
        const project1Score =
            formData?.projects && formData.projects.length > 0
                ? Number(formData.projects[0]?.projectScore || 0)
                : 0;

        if (project1Score === 0) {
            warningLabels.push("Project 1 Score");
        }

        return warningLabels;
    }, [formData]);

    return { getSoftMandatoryWarnings };
};
